import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";

export function getTutorGlobal(): Promise<ApiResponse> {
  return Axios.get(`v1/tutors/statistics/global`);
}
